import React from 'react';
import { Input, Label, Select_simple, Button } from "./ui";

const TabV_Vida_Deportiva = ({ data = {}, onChange }) => {

	const handleChange = (e) => {
		const { name, value } = e.target;
		onChange({ ...data, [name]: value });
	};

	const handleCheck = (e) => {
		const { name, checked } = e.target;
		onChange({ ...data, [name]: checked });
	};

	// Lógica para Disciplinas Dinámicas
	const disciplinas = data.disciplinas || [];

	
	// Agregar una nueva fila vacía
    const addDisciplina = () => {
        const nueva = { 
            nombreSeleccionada: '', 
			nombreManual: '',
            cantidad: 0, 
            categorias: '', // infantil / juvenil / mayores
            es_federado: '', 
            caracter: '' // Competición / Recreativo
        };
        onChange({ ...data, disciplinas: [...disciplinas, nueva] });
    };
	
	const updateDisciplina = (index, field, value) => {
        const nuevas = disciplinas.map((d, i) => {
            if (i === index) return { ...d, [field]: value };
            return d;
        });
        onChange({ ...data, disciplinas: nuevas });
    };

	const removeDisciplina = (index) => {
        const filtradas = disciplinas.filter((_, i) => i !== index);
        onChange({ ...data, disciplinas: filtradas });
    };

	return (
		<div className="space-y-10 p-2">

			{/* BLOQUE 1: DISCIPLINAS DEPORTIVAS (Optimizado) */}
			<section>
				<div className="flex items-center gap-4 mb-4 border-b-2 border-blue-500 pb-2">
					<h3 className="text-xl font-bold text-slate-800">1. Disciplinas deportivas</h3>
					<Button onClick={addDisciplina} variant="subse" size="sm" style={{ width: 'fit-content' }}>
						+ Agregar Disciplina
					</Button>
				</div>

				<div className="space-y-3">
					{disciplinas.length === 0 ? (
						<p className="text-sm text-slate-500 italic p-4 bg-slate-50 rounded-lg border border-dashed text-center">
							No hay disciplinas cargadas. Use el botón superior para agregar.
						</p>
					) : (
						<div className="overflow-x-auto">
							<table className="w-full text-left border-separate border-spacing-y-2">
								<thead>
									<tr className="text-slate-500 text-xs uppercase tracking-wider">
										<th className="px-3 py-2">Disciplina</th>
										<th className="px-3 py-2 text-center">Cant. Deportistas</th>
										<th className="px-3 py-2">Categorías</th>
										<th className="px-3 py-2 text-center">Federado</th>
										<th className="px-3 py-2 text-center">Carácter</th>
										<th className="px-3 py-2"></th>
									</tr>
								</thead>
								<tbody className="divide-y divide-transparent">
									{disciplinas.map((disc, index) => (
										<tr key={index} className="bg-slate-50 hover:bg-slate-100/80 transition-colors">
											<td className="p-3 rounded-l-lg">												
												<Select_simple
													placeholder="Seleccionar..."
													value={disc.nombreSeleccionada || ''}
													onChange={(e) => updateDisciplina(index, 'nombreSeleccionada', e.target.value)}
													options={[
														{ value: 'futbol', label: 'Fútbol' },
														{ value: 'basquet', label: 'Básquet' },
														{ value: 'voley', label: 'Vóley' },
														{ value: 'hockey', label: 'Hockey' },
														{ value: 'tenis', label: 'Tenis' },
														{ value: 'patin', label: 'Patín' },
														{ value: 'natacion', label: 'Natación' },
														{ value: 'artes_marciales', label: 'Artes Marciales' },
														{ value: 'boxeo', label: 'Boxeo' },
														{ value: 'gimnasia', label: 'Gimnasia Artística' },
														{ value: 'otra', label: 'OTRA (Especificar...)' },
													]}
												/>
												{disc.nombreSeleccionada === 'otra' && (
													<div className="mt-2 animate-in slide-in-from-top-1">
														<Input
															placeholder="Especificar..."
															value={disc.nombreManual || ''}
															onChange={(e) => updateDisciplina(index, 'nombreManual', e.target.value)}
														/>
													</div>
												)}
											</td>
											<td className="p-3 w-28">
												<Input
													type="number"
													value={disc.cantidad}
													className="text-center"
													onChange={(e) => updateDisciplina(index, 'cantidad', e.target.value)}
												/>
											</td>
											<td className="p-3">												
												<Select_simple
													value={disc.categorias}
													onChange={(e) => updateDisciplina(index, 'categorias', e.target.value)}
													options={[
														{ value: 'infantil', label: 'Infantil' },
														{ value: 'juvenil', label: 'Juvenil' },
														{ value: 'mayor', label: 'Mayor' }
													]}
													placeholder="Seleccionar..."
												/>
												
											</td>
											<td className="p-3 w-32">
												<Select_simple
													value={disc.es_federado}
													onChange={(e) => updateDisciplina(index, 'es_federado', e.target.value)}
													options={[
														{ value: 'Sí', label: 'Sí' },
														{ value: 'No', label: 'No' }
													]}
													placeholder="Seleccionar..."
												/>
											</td>
											<td className="p-3 w-40">
												<Select_simple
													value={disc.caracter}
													onChange={(e) => updateDisciplina(index, 'caracter', e.target.value)}
													options={[
														{ value: 'Competición', label: 'Competición' },
														{ value: 'Recreativo', label: 'Recreativo' }
													]}
													placeholder="Seleccionar..."
												/>
											</td>
											<td className="p-3 text-right rounded-r-lg">
												<button
													onClick={() => removeDisciplina(index)}
													className="p-2 text-slate-400 hover:text-red-600 transition-colors"
												>
													Eliminar
												</button>
											</td>
										</tr>
									))}
								</tbody>
							</table>
						</div>
					)}					
				</div>
			</section>
			
			{/* BLOQUE 2: ACTIVIDADES SOCIALES Y COMUNITARIAS (Actualizado con "Otros") */}
			<section>
				<h3 className="text-xl font-bold mb-4 border-b-2 border-blue-500 pb-2 text-slate-800">
					2. Actividades Sociales y Comunitarias
				</h3>
				<div className="bg-slate-50 p-6 rounded-xl border border-slate-200">
					<div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
						{[
							{ id: 'act_apoyo', label: 'Apoyo Escolar' },
							{ id: 'act_cultural', label: 'Actividades Culturales' },
							{ id: 'act_talleres', label: 'Talleres' },
							{ id: 'act_eventos', label: 'Eventos Comunitarios' },
							{ id: 'act_recreativas', label: 'Actividades Recreativas' },
							{ id: 'act_colonia', label: 'Colonias de Vacaciones' },
							{ id: 'act_sociales', label: 'Programas Sociales' },
							{ id: 'act_adultos', label: 'Espacios Adultos Mayores' },
							{ id: 'act_otras_check', label: 'Otras actividades...' }, // El disparador
						].map(item => (
							<div key={item.id} className="flex items-center space-x-3 p-2 bg-white rounded-md border border-slate-100 shadow-sm hover:bg-blue-50 transition-colors">
								<input
									type="checkbox"
									id={item.id}
									name={item.id}
									checked={!!data[item.id]}
									onChange={handleCheck}
									className="w-4 h-4 rounded text-blue-600 focus:ring-blue-500 cursor-pointer"
								/>
								<Label htmlFor={item.id} className="text-[13px] text-slate-700 cursor-pointer font-medium">
									{item.label}
								</Label>
							</div>
						))}
					</div>

					{/* Input manual condicional para "Otras actividades" */}
					{data.act_otras_check && (
						<div className="mt-4 p-4 bg-white rounded-lg border border-blue-100 animate-in slide-in-from-top-2">
							<Label className="text-xs font-bold text-blue-600 mb-1 block">Especifique las otras actividades:</Label>
							<Input
								name="act_otras_detalle"
								placeholder="Ej: Merendero, Radio comunitaria, Feria de emprendedores..."
								value={data.act_otras_detalle || ''}
								onChange={handleChange}
							/>
						</div>
					)}
				</div>
			</section>
			
			{/* BLOQUE 3: INCLUSIÓN (Optimizado con Select + Otra) */}
			<section>
				<h3 className="text-xl font-bold mb-4 border-b-2 border-blue-500 pb-2 text-slate-800">
					3. Inclusión
				</h3>
				<div className="bg-slate-50 p-6 rounded-xl border border-slate-200 space-y-6">

					<div className="max-w-md space-y-2">
						<Label className="font-bold text-slate-700">
							¿La institución desarrolla deporte adaptado o inclusivo?
						</Label>
						<Select_simple
							placeholder="Seleccionar..."
							name="deporteAdaptado"
							value={data.deporteAdaptado || ''}
							onChange={handleChange}
							options={[
								{ value: 'si', label: 'Sí' },
								{ value: 'no', label: 'No' },
							]}
						/>
					</div>

					{data.deporteAdaptado === 'si' && (
						<div className="grid grid-cols-1 md:grid-cols-2 gap-6 p-4 bg-white rounded-lg border border-blue-100 animate-in slide-in-from-top-2 shadow-sm">

							{/* Selector de Disciplina Adaptada */}
							<div className="space-y-2">
								<Label className="text-xs font-bold text-blue-600">Disciplina adaptada</Label>
								<Select_simple
									placeholder="Seleccionar disciplina..."
									name="adaptado_disc_select"
									value={data.adaptado_disc_select || ''}
									onChange={handleChange}
									options={[
										{ value: 'basquet_silla', label: 'Básquet sobre silla de ruedas' },
										{ value: 'futbol_inclusivo', label: 'Fútbol Inclusivo / Intelectual' },
										{ value: 'boccia', label: 'Boccia' },
										{ value: 'natacion_adaptada', label: 'Natación Adaptada' },
										{ value: 'atletismo_adaptado', label: 'Atletismo Adaptado' },
										{ value: 'tenis_mesa_adaptado', label: 'Tenis de Mesa Adaptado' },
										{ value: 'goalball', label: 'Goalball' },
										{ value: 'otra', label: 'OTRA (Especificar...)' },
									]}
								/>

								{/* Carga manual si elige "Otra" */}
								{data.adaptado_disc_select === 'otra' && (
									<div className="mt-2 animate-in fade-in">
										<Input
											name="adaptado_disc_manual"
											placeholder="Escriba la disciplina adaptada..."
											value={data.adaptado_disc_manual || ''}
											onChange={handleChange}
										/>
									</div>
								)}
							</div>

							<div className="space-y-2">
								<Label className="text-xs font-bold text-blue-600">Cant. aprox. de participantes</Label>
								<Input
									type="number"
									name="adaptado_cant"
									placeholder="0"
									value={data.adaptado_cant || ''}
									onChange={handleChange}
								/>
							</div>

						</div>
					)}
				</div>
			</section>

			{/* BLOQUE 4: PERSPECTIVA DE GÉNERO Y DIVERSIDAD */}
			<section>
				<h3 className="text-xl font-bold mb-4 border-b-2 border-blue-500 pb-2 text-slate-800">4. Perspectiva de Género y Diversidad</h3>
				<div className="bg-slate-50 p-6 rounded-xl border border-slate-200 space-y-6">
					<div className="grid grid-cols-1 md:grid-cols-2 gap-6">
						<div className="flex items-center space-x-3 bg-white p-3 rounded-md border border-slate-100 shadow-sm">
							
							<input type="checkbox" id="gen_equipos_fem" name="gen_equipos_fem" checked={!!data.gen_equipos_fem} onChange={handleCheck} />
							<Label htmlFor="gen_equipos_fem" className="text-sm font-medium cursor-pointer italic">¿Cuenta con equipos femeninos?</Label>
							{/* agregar insput cuantos? */}
							{data.gen_equipos_fem && (
								
									<Input
										type="number"
										name="gen_equipos_fem_cant"
										placeholder="Cantidad aprox. de disciplinas"
										value={data.gen_equipos_fem_cant || ''}
										onChange={handleChange}
									/>									
							)}
						</div>
						<div className="flex items-center space-x-3 bg-white p-3 rounded-md border border-slate-100 shadow-sm">
							<input type="checkbox" id="gen_equipos_mix" name="gen_equipos_mix" checked={!!data.gen_equipos_mix} onChange={handleCheck} />
							<Label htmlFor="gen_equipos_mix" className="text-sm font-medium cursor-pointer italic">¿Cuenta con equipos mixtos?</Label>
							{/* agregar insput cuantos? */}
							{data.gen_equipos_mix && (
									<Input
										type="number"
										name="gen_equipos_mix_cant"
										placeholder="Cantidad aprox. de disciplinas"
										value={data.gen_equipos_mix_cant || ''}
										onChange={handleChange}
									/>
							)}
						</div>
						<div className="flex items-center space-x-3 bg-white p-3 rounded-md border border-slate-100 shadow-sm">
							<input type="checkbox" id="gen_protocolo" name="gen_protocolo" checked={!!data.gen_protocolo} onChange={handleCheck} />
							<Label htmlFor="gen_protocolo" className="text-sm font-medium cursor-pointer italic">¿Posee protocolo de actuación ante situaciones de violencia o discriminación?</Label>
						</div>
						<div className="flex items-center space-x-3 bg-white p-3 rounded-md border border-slate-100 shadow-sm">
							<input type="checkbox" id="gen_comision" name="gen_comision" checked={!!data.gen_comision} onChange={handleCheck} />
							<Label htmlFor="gen_comision" className="text-sm font-medium cursor-pointer italic">¿Tiene referente o comisión de género dentro de la institución?</Label>
						</div>
						{/* agregar 2 preguntas */}
						{/* Si conocen Ley Micaela en el Deporte/ si realizaron la capacitación */}
						<div className="flex items-center space-x-3 bg-white p-3 rounded-md border border-slate-100 shadow-sm">
							<input type="checkbox" id="gen_ley_micaela" name="gen_ley_micaela" checked={!!data.gen_ley_micaela} onChange={handleCheck} />
							<Label htmlFor="gen_ley_micaela" className="text-sm font-medium cursor-pointer italic">¿Conocen la Ley Micaela en el Deporte?</Label>
							<input type="checkbox" id="gen_capacitacion" name="gen_capacitacion" checked={!!data.gen_capacitacion} onChange={handleCheck} />
							<Label htmlFor="gen_capacitacion" className="text-sm font-medium cursor-pointer italic">¿Realizaron la capacitación?</Label>
						</div>
						<div className="flex items-center space-x-3 bg-white p-3 rounded-md border border-slate-100 shadow-sm">
							
						</div>
					</div>

					<div className="pt-4 border-t border-slate-200 space-y-4">
						<div className="max-w-md">
							<Label className="font-bold text-slate-700 italic">¿Participan mujeres en la Comisión Directiva?</Label>
							<Select_simple
								placeholder="Seleccionar..."
								name="mujeresEnCD"
								value={data.mujeresEnCD || ''}
								onChange={handleChange}
								options={[{ value: 'si', label: 'Sí' }, { value: 'no', label: 'No' }]}
							/>
						</div>
						{data.mujeresEnCD === 'si' && (
							<div className="p-4 bg-white rounded-lg border border-slate-200 animate-in fade-in">
								<Label className="text-xs font-bold text-blue-600">¿En qué cargos?</Label>
								<Input name="mujeresCargos" placeholder="Ej: Presidenta, Vocales..." value={data.mujeresCargos || ''} onChange={handleChange} />
							</div>
						)}
					</div>
				</div>
			</section>

		</div>
	);
};

export default TabV_Vida_Deportiva;